import { Component } from '@angular/core';

@Component({
  selector: 'app-merchant-location-tab',
  templateUrl: './merchant-location-tab.component.html',
  styleUrls: ['./merchant-location-tab.component.scss']
})
export class MerchantLocationTabComponent {

}
